// Bonne Nuit Dehors : recalcul du texte d'un pack quand le client change la variante de l'article 1 (ou l'article alternatif).
// Usage : <bnd-offre-pack data-pack="18900" data-autres="10800" data-modele="... [separes] ... [pack] ... [economie] ..."> avec un
// <select data-bnd-choix> dont chaque option porte data-prix (prix de la variante) et data-pack (prix du pack avec elle).
// Couleurs coordonnées : l'option porte aussi data-autres (prix des articles 2 et 3) et data-couleur-1 à 3, recopiées dans [data-bnd-couleur].
if (!customElements.get('bnd-offre-pack')) {
  customElements.define(
    'bnd-offre-pack',
    class extends HTMLElement {
      connectedCallback() {
        this.choix = this.querySelector('select[data-bnd-choix]');
        this.choix?.addEventListener('change', this.recalculer);
        if (this.dataset.siVariante) {
          try { this.titres = JSON.parse(this.querySelector('[data-bnd-titres]')?.textContent || '{}'); } catch (e) { this.titres = {}; }
          this.zone = this.closest('.product-information') || document;
          this.observateur = new MutationObserver(() => this.suivreVariante());
          this.observateur.observe(this.zone, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
          this.zone.addEventListener('change', this.surChangement);
          this.suivreVariante();
        }
      }

      disconnectedCallback() {
        this.choix?.removeEventListener('change', this.recalculer);
        this.observateur?.disconnect();
        this.zone?.removeEventListener('change', this.surChangement);
      }

      surChangement = () => requestAnimationFrame(() => this.suivreVariante());

      suivreVariante() {
        const champ = this.zone.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        const titre = this.titres[champ?.value];
        if (titre === undefined) return;
        const cache = !titre.includes(this.dataset.siVariante);
        if (this.hidden !== cache) this.hidden = cache;
        // Couleur du pack alignée sur la variante choisie sur la fiche (sac bleu choisi : pack bleu), seulement quand cette variante change
        if (champ.value === this.varianteSuivie) return;
        this.varianteSuivie = champ.value;
        if (this.choix && [...this.choix.options].some((o) => o.value === champ.value) && this.choix.value !== champ.value) {
          this.choix.value = champ.value;
          this.recalculer();
        }
      }

      format(c) {
        return `${(c / 100).toFixed(2).replace('.', ',').replace(',00', '')}\u00a0€`;
      }

      recalculer = () => {
        const option = this.choix?.selectedOptions[0];
        if (!option) return;
        const separes = Number(option.dataset.prix || 0) + Number(option.dataset.autres ?? this.dataset.autres ?? 0);
        for (const n of [1, 2, 3]) {
          const couleur = option.getAttribute(`data-couleur-${n}`);
          if (couleur === null) continue;
          this.querySelectorAll(`[data-bnd-couleur="${n}"]`).forEach((e) => { if (e.textContent !== couleur) e.textContent = couleur; });
        }
        const pack = Number(option.dataset.pack || this.dataset.pack || 0);
        const texte = (this.dataset.modele || '')
          .replace('[separes]', this.format(separes))
          .replace('[pack]', this.format(pack))
          .replace('[economie]', this.format(separes - pack));
        const corps = this.querySelector('[data-bnd-corps]');
        if (corps) corps.textContent = texte;
        const montant = this.querySelector('[data-bnd-montant]');
        if (montant) montant.textContent = this.format(pack);
      };
    }
  );
}
